import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'file';

const originalDimensions = {
    width: 24,
    height: 24,
};

export const IconFile = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'tertiary-400';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;

    return (
        <svg
            aria-labelledby={iconId}
            className={cx(addClasses)}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>File Icon</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M5.857 2h7.88a1.5 1.5 0 01.968.355l4.764 4.029A1.5 1.5 0 0120 7.529v12.554c0 1.79-.02 1.917-1.857 1.917H5.857C4.02 22 4 21.874 4 20.083V3.917C4 2.127 4.02 2 5.857 2z"
                    fill={fill}
                    fillRule="nonzero"
                    opacity=".3"
                />
                <rect fill={fill} x="6" y="11" width="9" height="2" rx="1" />
                <rect fill={fill} x="6" y="15" width="5" height="2" rx="1" />
            </g>
        </svg>
    );
};
